var map = {
	"./XploraFooter": [
		8725,
		725
	],
	"./XploraFooter.styles": [
		2354,
		354
	],
	"./XploraFooter.styles.ts": [
		2354,
		354
	],
	"./XploraFooter.tsx": [
		8725,
		725
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 5763;
module.exports = webpackAsyncContext;